/**
 * @generated SignedSource<<258c7741d5a8816e2624990fce4b8586>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Status = "ACTIVE" | "ARCHIVED" | "DRAFT" | "INACTIVE" | "TEMPLATE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type processDefinitionQueryFragment$data = {
  readonly definitionHash: string;
  readonly definitionId: string;
  readonly definitionKey: string;
  readonly definitionName: string;
  readonly definitionVersion: string | null | undefined;
  readonly definitionXml: string;
  readonly dirtyFlag: boolean;
  readonly id: string;
  readonly siteUrl: string;
  readonly status: Status;
  readonly " $fragmentType": "processDefinitionQueryFragment";
};
export type processDefinitionQueryFragment$key = {
  readonly " $data"?: processDefinitionQueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"processDefinitionQueryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "processDefinitionQueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "definitionKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "definitionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "definitionName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "definitionVersion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "definitionXml",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "siteUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dirtyFlag",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "definitionHash",
      "storageKey": null
    }
  ],
  "type": "ProcessDefinition",
  "abstractKey": null
};

(node as any).hash = "28843ad7236bd0e52e700ddefa170d58";

export default node;
